import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { selectExpressLimits } from '../../../selectors/stakeTypes/express';
import DefaultStakeTypeFooterBar from './DefaultStakeTypeFooterBar';

// ---

type StoreProps = {
  maxValue: number;
  betId?: number;

};

const mapStateToProps = (state: ReduxState): StoreProps => {
  const limits = selectExpressLimits(state);
  return {
    maxValue: limits.max,
  };
};

export default connect(mapStateToProps)(DefaultStakeTypeFooterBar);
